import React from "react";
import NextImage from "./NextImage";
const baseURL =
  process.env.REACT_APP_BASE_URL ?? "https://ipublisher-microservices.6lgx.com";
const Loader = ({ width = "55", height = "90" }) => {
  return (
    <div style={{ textAlign: "center", height: "100vh" }}>
      <NextImage
        src={`${baseURL}/public//assets/images/svg/loader.svg`}
        width={width}
        height={height}
      />
    </div>
  );
};

export default Loader;
